module.exports = __webpack_public_path__ + "static/media/QualityPic03.6b7a40f8.jpg";